<template>
  <div id="app">
    <auth-check>
      <email-designer></email-designer>
    </auth-check>
  </div>
</template>

<script>
import AuthCheck from './components/AuthCheck.vue';
import EmailDesigner from './components/EmailDesigner.vue';
import 'vue-loading-overlay/dist/css/index.css';
import 'vue-select/dist/vue-select.css';

export default {
  name: 'App',
  data: function () {
    return {
      pageCount: 10
    };
  },
  components: {
    AuthCheck,
    EmailDesigner
  }
};
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
  width: 100%;
}

.multiselect__tag {
  background-color: #286090;
  border-color: #204d74;
}
.multiselect__tag-icon::after {
  color: #fff;
}
.multiselect__tag-icon:hover {
  background-color: #204d74;
}
.multiselect__tag-icon:focus {
  background-color: #204d74;
}
</style>
